import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { PRODUCT } from '../data/constants';
export function SystemSection() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-162" data-mp="3biwp78cfpoea">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-163" data-mp="3bhllt9mwiinp">
        <h2 className="text-center text-3xl leading-none text-navy sm:text-5xl" data-id="element-164" data-mp="36jsdob21feks">
          EVERYTHING YOU NEED.{' '}
          <span className="text-tech" data-id="element-165" data-mp="31l8v8kmnkkx6">ONE COMPLETE WELD INSPECTION VISUAL SYSTEM.</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-bold uppercase tracking-wide text-steel sm:text-lg" data-id="element-166" data-mp="2wth3i6rrg95g">
          6 Professional Welding Inspection Modules In One Organized System
        </p>

        <div className="mx-auto mt-3 max-w-4xl rounded-xl border-2 border-navy bg-white p-3 text-center shadow-sm sm:p-5" data-id="element-167" data-mp="2nu3s38k2tai3">
          <p className="font-heading text-xl uppercase leading-tight text-navy sm:text-3xl" data-id="element-168" data-mp="2itprucopv4um">
            🔍 {PRODUCT}
          </p>
          <p className="mt-1.5 text-sm leading-snug text-steel sm:text-base" data-id="element-169" data-mp="2dxh7mkvnwlgl">
            {PRODUCT} brings weld joint analysis, discontinuity identification, visual testing
            procedures, precision measurement, NDT methods, quality evaluation, and practical
            inspection documentation together in one complete professional reference system.
          </p>
          <p className="mx-auto mt-2 w-fit max-w-full rounded-lg bg-navy px-3 py-1 font-display text-2xs font-bold uppercase tracking-wide text-white sm:text-base" data-id="element-170" data-mp="z0ek1h16qvpr">
            IDENTIFY → <span className="text-gold" data-id="element-171" data-mp="1rnr3hic1uneu">VISUALIZE</span> → MEASURE →{' '}
            <span className="text-gold" data-id="element-172" data-mp="1cs1gbgv4o48j">INTERPRET</span> → EVALUATE →{' '}
            <span className="text-gold" data-id="element-173" data-mp="1ctw6b9l9amjh">DOCUMENT</span>
          </p>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-174" data-mp="1hsphuwgzg3h0">
          {modules.map(module => <article key={module.title} className="rounded-xl border border-metal/60 bg-white p-3 shadow-sm sm:p-4" style={{
          borderLeft: `6px solid ${module.color}`
        }} data-id="element-175" data-mp="1epl1udfotxz">
              <h3 className="flex items-start gap-1.5 text-base leading-tight text-navy sm:text-lg" data-id="element-176" data-mp="23za4qx58dw8t">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-tech" strokeWidth={3} aria-hidden="true" data-id="element-177" data-mp="1z81pvll4tio9" />
                {module.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-178" data-mp="1pb6xzljd6giy">{module.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}